// private method to generate logo base on first 2 letter from name
// works with space , - _ characters
export const toFirstLetters = (name: string): string =>
  name
    .split(/,|_|-| /)
    .filter(item => item)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join('')
